// in posts.js
import * as React from "react";
import { List, Datagrid, TextField, ReferenceField, Filter, TextInput, Pagination, TopToolbar, CreateButton, DeleteButton, EditButton, ImageField } from 'react-admin';

const ResiliationModelPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

const ResiliationModelActions = (props) => (
    <TopToolbar>
        <CreateButton />
    </TopToolbar>
);

const ResiliationModelsFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Identifiant" source="id" alwaysOn />
        <TextInput label="Nom" source="name" alwaysOn />
    </Filter>
);

export const ResiliationModelsList = (props) => (
    <List {...props} pagination={<ResiliationModelPagination />} title="Préfectures" actions={<ResiliationModelActions />} filters={<ResiliationModelsFilter />}>
        <>
            <Datagrid>
                <TextField label="Identifiant" source="id" />
                <TextField label="Nom" source="name" />
                <ImageField label="Logo" source="logo" />
                <ReferenceField label="Catégorie" source="resiliationCategory.id" reference="ResiliationCategory">
                    <TextField source="name" />
                </ReferenceField>
                <EditButton />
                <DeleteButton />
            </Datagrid>
        </>
    </List>
);